import { useMemo } from 'react';

import { CommandLauncherAction, useCommandLauncher } from 'utils/commandLauncher';
import { pubSub } from 'utils/pubSub';
import { useAppSelector } from 'utils/redux/useAppSelector';

/** Returns wrap-up (ACW) actions for the command launcher. */
export function useWrapUpActions(): readonly CommandLauncherAction[] {
  const { createAction } = useCommandLauncher();

  // Get wrap-up notifications
  const wrapUpNotifications = useAppSelector((state) =>
    state.notifications.currentNotifications.filter(
      ({ type }) => type === 'acw',
    ),
  );
  const hasWrapUpNotifications = wrapUpNotifications.length > 0;

  return useMemo(() => {
    if (!hasWrapUpNotifications) {
      return [];
    }

    return [
      createAction({
        label: 'Extend wrap-up time',
        aliases: [
          'extend acw',
          'more time',
          'wrap up extend',
          'after call work',
        ],
        icon: 'clock',
        section: 'Wrap-up',
        commandName: 'conversation:extendWrapUp',
        performFn: () => {
          pubSub.publish('command:conversation:extendWrapUp');
        },
      }),
      createAction({
        label: 'End wrap-up',
        aliases: [
          'end acw',
          'finish wrap up',
          'complete acw',
          'after call work',
        ],
        icon: 'check-circle',
        section: 'Wrap-up',
        commandName: 'conversation:endWrapUp',
        performFn: () => {
          pubSub.publish('command:conversation:endWrapUp');
        },
      }),
    ];
  }, [createAction, hasWrapUpNotifications]);
}

